import { parsePearsonItemsIndex } from './nextPearsonSittingPhase';

export function showLnatPearsonHighlightToolbar({
  pearsonPlayer,
  isLnatExam,
  isReview,
  isPostExam,
  tmuaPaperPhase,
} = {}) {
  return Boolean(
    pearsonPlayer
    && isLnatExam
    && !isReview
    && !isPostExam
    && parsePearsonItemsIndex(tmuaPaperPhase) != null
  );
}
